import { pathValidationFactory } from 'tmw-validation'

let validator = pathValidationFactory([])

export const setValidatorCourses = courses => {
  validator = pathValidationFactory(courses)
  return validator
}

export const getValidator = () => {
  return validator
}



// WEBPACK FOOTER //
// ./src/services/courseValidation.js